import axios from "axios";
import { useEffect, useState } from "react";
import Link from "@/components/atoms/Link";

interface Ticket {
	id: string;
	displayid: string;
	subject: string;
	internalOwner: string;
	lastActivity: string;
}

type Props = {
	accountId: string;
};

const WatchedTicketsTable = ({accountId}: Props) => {
	const [tickets, setTickets] = useState<Ticket[]>([]);

	useEffect(() => {
		const fetchWatchedTickets = async () => {
			try {
				const response = await axios.get('/tickets/listing', {
					params: { watched: true, ticket_status_ids: [1, 2, 3, 4, 7, 8, 14, 16, 20], account_ids: [accountId] }
				});

				if (response?.data?.tickets?.length > 0) {
					const transformedTickets = response?.data?.tickets?.slice(0, 5).map((item: any) => ({
						displayid: item.display_id,
						id: item.id,
						subject: item.subject,
						internalOwner: item.internal_owner?.name || "",
						lastActivity: item.updated_at || ""
					}));
					setTickets(transformedTickets);
				}
			} catch (error) {
				console.error("Error fetching tickets:", error);
			}
		};

		fetchWatchedTickets();
	}, [accountId]);

	return (
		<div className="p-4 border border-border rounded-lg shadow-md">
			<div className="flex items-center mb-4">
				<span className="text-yellow-500 mr-2">👁️</span>
				<h3 className="text-lg font-semibold">Watched tickets</h3>
			</div>
			<div className="h-[290px] overflow-y-auto">
				<table className="w-full table-fixed border-collapse">
					<thead>
						<tr className="border-b border-border">
							<th className="w-2/12 px-4 py-2 text-left text-sm font-semibold text-gray-600">ID</th>
							<th className="w-3/12 px-4 py-2 text-left text-sm font-semibold text-gray-600">Subject</th>
							<th className="w-4/12 px-4 py-2 text-left text-sm font-semibold text-gray-600">Internal Owner</th>
							<th className="w-4/12 px-4 py-2 text-left text-sm font-semibold text-gray-600">Last Activity</th>
						</tr>
					</thead>
					<tbody>
						{tickets && tickets.length > 0 ? (tickets?.map((ticket, index) => (
							<tr
								key={index}
								className={`border-b ${index % 2 === 0 ? '' : ''}`}
							>
								<td className="px-4 py-2 text-sm font-medium"><a href={`/tickets/${ticket.id}`}> {ticket.displayid}</a></td>
								<td className="px-4 py-2 text-sm truncate"><a href={`/tickets/${ticket.id}`}> {ticket.subject}</a></td>
								<td className="px-4 py-2 text-sm truncate"><a href={`/tickets/${ticket.id}`}> {ticket.internalOwner}</a></td>
								<td className="px-4 py-2 text-sm"><a href={`/tickets/${ticket.id}`}> {ticket.lastActivity}</a></td>
							</tr>
						))): (
							<tr>
								<td colSpan={4} className="text-center">No watched tickets</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default WatchedTicketsTable;
